// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_3r3MO","avatar":"index_avatar_ALPgk","menuIcon":"index_menuIcon__XnhK"};